export default "__VITE_ASSET__DJ6R1HS2__"